import { Avatar as AntAvatar } from "antd";
import type { AvatarProps as AntAvatarProps } from "antd";
import { FaUser } from "react-icons/fa";

interface AvatarProps extends AntAvatarProps {
  name?: string;
}

export function Avatar({ name, children, ...props }: AvatarProps) {
  // Obtener iniciales del nombre
  const getInitials = (name?: string) => {
    if (!name) return null;
    const parts = name.split(" ") || ['A', 'A'];
    if (parts.length >= 2) {
      return `${parts[0]?.[0] || 'A'}${parts[1]?.[0] || 'A'}`.toUpperCase();
    }
    return parts[0]?.[0]?.toUpperCase() || 'A';
  };

  const initials = getInitials(name);

  return (
    <AntAvatar {...props}>
      {children || initials || <FaUser />}
    </AntAvatar>
  );
}
